import React, { useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import Container from '@mui/material/Container'
import './AdditionalInformation.scss'

const AdditionalInformation = React.memo(({ additionalInformationEntity }) => {
  const [additionalInformation, setAdditionalInformation] = useState({})

  useEffect(() => {
    if (additionalInformationEntity) {
      setAdditionalInformation(additionalInformationEntity)
    }
  }, [additionalInformationEntity])

  return (
    <div className="additional-information">
      <h2>Additional Information</h2>

      <div className="additional-section">
        <Container maxWidth="lg">
          <Grid container spacing={2}>
            <Grid size={12}></Grid>
            <Grid size={12}>
              <form noValidate autoComplete="off">
                <Grid container>
                  <Grid size={12} className="container-field">
                    {additionalInformation && additionalInformation.hasAdditionalInformation && (
                      <Grid>
                        <label className="main-title-label">
                          Is there anything else that would be important for emergency responders to
                          know about the people in this location or about the location itself?
                        </label>
                      </Grid>
                    )}

                    {additionalInformation && additionalInformation.information && (
                      <Grid>
                        <Grid className="container-field">{additionalInformation.information}</Grid>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  )
})

export default AdditionalInformation
